
import { isPositiveInteger } from "@common/src/utils/verify";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const finance = namespace("finance");
const app = namespace("app");

@Component({})
export default class SettlementCycleDialog extends Vue {
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @finance.Action createDeferredCycle;
  @finance.Action queryDeferredCycleList;
  cycleList = [];
  definitionNewItem = {
    billingCycleName: "",
    billingCycleValue: "",
    new: true
  };
  handleInsertRow(index) {
    this.cycleList.splice(index + 1, 0, Object.assign({}, this.definitionNewItem));
  }
  handleDeleteRow(index) {
    if (this.cycleList.length > 1) {
      this.cycleList.splice(index, 1);
    } else {
      this.$message.warning("最少设置第一个周期");
    }
  }
  visible = false;
  async open() {
    this.visible = true;
    await this.getCycleList();
    if (!this.cycleList.length) {
      this.handleInsertRow(0);
    }
  }
  getCycleList() {
    return this.queryDeferredCycleList().then(res => {
      this.cycleList = res?.data || [];
    });
  }
  handleConfirm() {
    const nameArr = [];
    const cycleArr = [];
    for (let i = 0; i < this.cycleList.length; i++) {
      const item = this.cycleList[i];
      if (nameArr.includes(item.billingCycleName)) {
        return this.$message.error("账期名称不能重复,请重新设置");
      } else if (cycleArr.includes(item.billingCycleValue)) {
        return this.$message.error("账期时间不能重复,请重新设置");
      } else if (!isPositiveInteger(item.billingCycleValue)) {
        return this.$message.error("账期时间为正整数");
      }
      nameArr.push(item.billingCycleName);
      cycleArr.push(String(item.billingCycleValue));
    }
    this.createDeferredCycle({
      configs: this.cycleList
    }).then(() => {
      this.$message.success("保存成功");
      this.visible = false;
      this.getCycleList();
    });
    this.$emit("saved");
  }
}
